export default {
  manufacturers: '成衣生产厂商',    
    rights: '角色权限',    
    coupon: '平台优惠券',
    images: '客户的杂图',
    datainit: '分店初始化数据',
    templatedetails:'系统集成模板详情',
    sharedimgs: '共享版型图片',
    orgdetails: '分店详情',
    productDetails: '版型详情',
    clothSize: '服装尺码',
    platformTitle: '平台管理',
    platform:{
      platforminfo: '平台信息',
      accounts: '平台账号',
      defaultFunctions:'新店初始权限设置', 
      orgrights:'分店C端机构权限',
      feedback: '客户反馈',
    },
    ordersTitle: '订单管理',
    orders: {
      bokesOrder: '电子版订单',
      clothsOrders: '成衣现货订单',
      decorationOders: '饰品订单',
      fabricsOrder: '面辅料订单',
      physicalBokes: '纸质版订单',
      physicalPrinting: '纸质版打印',
      tailoredOrders: '量体订单',
      tailoredBokes: '来图版型订单',
      tailoredCloths: '成衣定制订单',
      clothsOrder: '成衣现货订单',
      tailoredMade: '量体定制版型订单',
      tailoredMadeDetail:'量体定制订单详情',
      videoTeching: '教学课程订单',
      takeOrders:'成衣接单',
      upgration:'会员升级充值订单',
      autoscaleOrders:'智能量体订单'
    },
    customersTitle:'客户管理',
    customers:{
      customers:'客户管理',
      levels:'会员等级',
      notes:'平台优惠券',
      extention:'会员续期审核',
    },
    auditedTitle:'审核管理',
    audited:{
      ref:'版型引用审核',
      shared:'版型共享审核',
      settings:'审核设置',
      fabrics:'面料辅料审核',
      decorations:'服装饰品审核',
      bokes:'版型成衣审核',
      upShare:'平台售卖审核'
    },
    productsTitle:'商品管理',
    products: {
      bokes: '版型管理',
      branchProducts:'版型管理',
      cloths: '成衣管理',
      clothDetails: '成衣明细',
      parentSharedprds:'平台商品',
      upsharedProducts:'分店商品平台售卖',
      fabrics: '面料管理',
      upshare:'分店上平台',
      fabricDetails:'面料详情',
      accessories:'辅料管理',
      decorationDetails:'饰品详情',
      accessoryDetails:'辅料详情',
      decoration:'饰品管理',
      sharingFromOther:'分店商品',
      binding:'批量绑定',
      accessoriesDetails:'辅料详情'
    },
    systemTitle: '系统设置',
    system: {
      clothCategory: '商品类别',
      clothStyle: '服装风格',
      clothSize: '服装尺码',
      productUnit: '商品单位',
      clothSizeViewer: '服装尺码详情',
      videos:'帮助视频',
      settings:'系统参数设置',
      operationLogs:'操作日志',
      fabricCategories:'面料分类',
      messages:'全站消息',
      clothSizeTemplate:'尺码模板管理',
      depositeSettings:'账户充值设置',
      course:'制版教学',
      videoCategory:'视频分类'
    },
    inventoryTitle:'库存管理',
    inventory:{
      storage:'商品库存',
      instore:'入库详情',
      outstore:'出库详情',
    },
    financialTitle:'财务管理',
    financial:{
      recharge:'会员购买记录',
      myaccount:'资金账户',
      accountStatements:'流水记录',
      withdrawal:'资金提现',
      depositeRecords:'账户充值记录',
      depositeHistories:'账户充值设置'
    },
    '新增':'新增','启用':'启用','禁用':'禁用',
    '您确定要重置该机构的管理员密码吗？':'您确定要重置该机构的管理员密码吗？',
    '确认重置':'确认重置','重置密码':'重置密码',
    '接收':'接收','不收':'不收','不可操作':'不可操作',
    '新增账号':'新增账号',
    '修改管理员密码':'修改管理员密码',
    '登录名:':'登录名:','用户名:':'用户名:','联系电话:':'联系电话:',
    '登录密码:':'登录密码:','账户角色:':'账户角色:',
    '原始密码:':'原始密码:','新密码:':'新密码:','验证码:':'验证码:',
    '请录入账号登录名!':'请录入账号登录名!','录入登录名':'录入登录名',
    '请录入录入用户名!':'请录入录入用户名!','录入用户名':'录入用户名',
    '请录入联系电话!':'请录入联系电话!','录入联系电话':'录入联系电话',
    '请录入录入密码!':'请录入录入密码!','录入密码':'录入密码',
    '请选择账户角色!':'请选择账户角色!',
    '请录入原始密码!':'请录入原始密码!',
    '请录入短信验证码!':'请录入短信验证码!',
    '获取验证码':'获取验证码',
    '设置成功':'设置成功','发送成功':'发送成功',
    '密码已重置为123456':'密码已重置为123456',
    '请录入新密码!':'请录入新密码!',
    '密码至少6位，且包含字母与数字。':'密码至少6位，且包含字母与数字。',
    '原始密码不正确。':'原始密码不正确。','密码修改成功。':'密码修改成功。',
    '账号添加成功。':'账号添加成功。','账号添加失败：':'账号添加失败：',
    '账号修改成功。':'账号修改成功。','账号修改失败：':'账号修改失败：',
    '版型审核':'版型审核','面料审核':'面料审核','饰品审核':'饰品审核',
    '系统添加':'系统添加','管理员添加':'管理员添加',
    '图标':'图标','手机号码':'手机号码',
    '接收订单消息':'接收订单消息','接收审核消息':'接收审核消息',
    '角色':'角色','账号来源':'账号来源',
    '创建时间':'创建时间','最后登录时间':'最后登录时间',
    '秒后重新获取':'秒后重新获取',
    '登录名、手机号码、用户名':'登录名、手机号码、用户名',
    '雨滴':'雨滴',
    '修改了超级管理员密码':'修改了超级管理员密码',
    '个人信息':'个人信息','更新图标':'更新图标','个人资料':'个人资料',
    '登录名':'登录名','用户名':'用户名','手机号':'手机号','登录时间':'登录时间',
    '所属机构':'所属机构','机构类型':'机构类型','编辑个人信息':'编辑个人信息',
    '请输入昵称!':'请输入昵称!','请输入手机号!':'请输入手机号!',
    '所属机构:':'所属机构:','保存更改':'保存更改','机构信息':'机构信息',
    'LOGO白:':'LOGO白:','LOGO黑:':'LOGO黑:','客服链接:':'客服链接:',
    '机构全称:':'机构全称:','请输入机构全称!':'请输入机构全称!',
    '网站地址:':'网站地址:','机构简称:':'机构简称:','请输入机构简称!':'请输入机构简称!',
    '营业执照号:':'营业执照号:','请输入营业执照号!':'请输入营业执照号!',
    '营业执照:':'营业执照:','机构所在地:':'机构所在地:','请输入机构所在地!':'请输入机构所在地!',
    '机构责任人:':'机构责任人:','请输入机构责任人!':'请输入机构责任人!',
    '责任人电话:':'责任人电话:','请输入责任人电话!':'请输入责任人电话!',
    '责任人证件号:':'责任人证件号:','请输入责任人身份证号!':'请输入责任人身份证号!',
    '注册类型:':'注册类型:','微信子商户号:':'微信子商户号:','微信APPID:':'微信APPID:',
    '您确定要删除该配置吗，删除后将会影响系统正常支付？':'您确定要删除该配置吗，删除后将会影响系统正常支付？',
    '未配置':'未配置','扫码绑定打单员':'扫码绑定打单员',
    '首页设置':'首页设置','首页标题:':'首页标题:','请输入首页标题!':'请输入首页标题!',
    '首页描述:':'首页描述:','请输入首页描述!':'请输入首页描述!',
    '首页图片:':'首页图片:','绑定发货物流':'绑定发货物流',
    '绑定新物流公司':'绑定新物流公司','微信支付':'微信支付',
    '分账账户':'分账账户','开通微信支付':'开通微信支付',
    '请输入微信子商户号!':'请输入微信子商户号!','请输入微信APPID!':'请输入微信APPID!',
    '绑定物流公司':'绑定物流公司','物流公司:':'物流公司:','请选择物流公司!':'请选择物流公司!',
    '请选择物流公司':'请选择物流公司','物流账号:':'物流账号:','请录入物流账号!':'请录入物流账号!',
    '请录入物流账号':'请录入物流账号','绑定密码:':'绑定密码:',
    '绑定失败：':'绑定失败：',
    '解除绑定失败：':'解除绑定失败：','解除绑定成功':'解除绑定成功',
    '代码':'代码','附加码':'附加码','添加时间':'添加时间',
    '域名已存在':'域名已存在',
    '图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1':'图片尺寸太小，不符合要求，至少50*50，且长宽比为1:1',
    '图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1':'图片尺寸太大，不符合要求，宽高不能超过800*800，且长宽比为1:1',
    '编辑个人账户信息':'编辑个人账户信息','保存失败，手机号码可能已使用！':'保存失败，手机号码可能已使用！',
    '请录入正确的域名地址，不包含http/https,例demo':'请录入正确的域名地址，不包含http/https,例demo',
    '更新成功':'更新成功','更新失败，请稍后再次尝试。':'更新失败，请稍后再次尝试。',
    'LOGO图片不符合要求,请重新选择。':'LOGO图片不符合要求,请重新选择。',
    '编辑机构信息':'编辑机构信息','保存成功':'保存成功',
    '企业':'企业','个人':'个人',
    '请输入客户姓名、手机号码开始查询':'请输入客户姓名、手机号码开始查询','客户类别':'客户类别',
    '会员级别':'会员级别','导出号码':'导出号码','个':'个',
    '新增会员':'新增会员','会员昵称:':'会员昵称:','请录入会员昵称!':'请录入会员昵称!',
    '密码:':'密码:','如不输入，密码默认123456':'如不输入，密码默认123456',
    '手机号码:':'手机号码:','会员等级:':'会员等级:','会员长度':'会员长度','会员长度:':'会员长度:',
    '会员续期':'会员续期','续期长度:':'续期长度:','请选择续期长度!':'请选择续期长度!',
    '一个月':'一个月','三个月':'三个月','六个月':'六个月','一年':'一年','两年':'两年','三年':'三年',
    '自定义':'自定义','续期长度':'续期长度','到期时间:':'到期时间:','请选择到期截止时间!':'请选择到期截止时间!',
    '续期方式:':'续期方式:','请选择续期方式!':'请选择续期方式!',
    '对公汇款购买升级':'对公汇款购买升级','会员延期':'会员延期','其它':'其它','续期方式':'续期方式',
    '备注:':'备注:','续期备注':'续期备注','手动续期':'手动续期',
    '续版数量:':'续版数量:','请录入续版数量!':'请录入续版数量!',
    '支付金额:':'支付金额:','支付金额!':'支付金额!','续期时长:':'续期时长:','请选择续期长度':'请选择续期长度',
    '截止时间:':'截止时间:','请录入过期结止时间!':'请录入过期结止时间!',
    '手动延期':'手动延期','对公转账':'对公转账','线下转账':'线下转账',
    '您确定要删除这个客户吗？删除后不可恢复！':'您确定要删除这个客户吗？删除后不可恢复！',
    '发券':'发券','退卡':'退卡','你确定要':'你确定要','该账号吗？':'该账号吗？',
    '你确定要重置该账号密码吗？默认密码为123456':'你确定要重置该账号密码吗？默认密码为123456',
    '会员备注':'会员备注','更新备注':'更新备注','会员续期记录':'会员续期记录',
    '序号':'序号','时长':'时长','续期时间':'续期时间','操作员':'操作员',
    '个月':'个月','驳回:':'驳回:','续期通过':'续期通过','待支付':'待支付','天':'天',
    '您确定将当前账号解除黑名单吗？':'您确定将当前账号解除黑名单吗？',
    '您确定将当前账号拉入黑名单吗？':'您确定将当前账号拉入黑名单吗？',
    '充值':'充值','消费':'消费','退费':'退费',
    '变更会员级别':'变更会员级别','请选择一个会员级别!':'请选择一个会员级别!',
    '从一般会员升级为会员，过期日期为当天，请及时为会员续期。':'从一般会员升级为会员，过期日期为当天，请及时为会员续期。',
    '储值账户退款':'储值账户退款','账户本金':'账户本金','请录入退款金额!':'请录入退款金额!',
    '剩余赠额':'剩余赠额','已用赠额':'已用赠额','实退金额':'实退金额',
    '退款说明':'退款说明','请录入退款说明!':'请录入退款说明!','确定退卡':'确定退卡',
    '下载限制':'下载限制','单日下载限制:':'单日下载限制:','单日最大下载限制数量!':'单日最大下载限制数量!',
    '失效日期:':'失效日期:','请录入失效日期!':'请录入失效日期!',
    '失效时间:':'失效时间:','请录入失效时间!':'请录入失效时间!','说明':'说明',
    '1、限制会员单日下载电子版型数量。':'1、限制会员单日下载电子版型数量。',
    '2、为0，此设置不限制。':'2、为0，此设置不限制。',
    '3、不为0且在有限时间内，会限制。':'3、不为0且在有限时间内，会限制。',
    '4、该限制优先于全局限制。':'4、该限制优先于全局限制。',
    '发放优惠券':'发放优惠券','券名称:':'券名称:',
    '普通会员':'普通会员','3个月':'3个月','6个月':'6个月','12个月':'12个月','终身':'终身',
    '客户充值/消费明细':'客户充值/消费明细','订单号':'订单号','充值金额':'充值金额',
    '赠送金额':'赠送金额','充值时间':'充值时间','类型':'类型',
    '下载余量':'下载余量','账户余额':'账户余额','会员过期时间':'会员过期时间',
    '过期天数':'过期天数','备注':'备注','黑名单':'黑名单',
    '1个月':'1个月','2个月':'2个月','半年':'半年','二年':'二年','四年':'四年','五年':'五年',
    '未过期':'未过期','已过期':'已过期','30天内过期':'30天内过期','已禁用':'已禁用','储值用户':'储值用户',
    '实退金额不能小于0!':'实退金额不能小于0!',
    '发放成功':'发放成功','当前客户不符合该券的发放要求，发放失败！':'当前客户不符合该券的发放要求，发放失败！',
    '请选择需要发放的优惠券！':'请选择需要发放的优惠券！','备注更新成功':'备注更新成功',
    '本金':'本金','已使用赠额':'已使用赠额','实退':'实退',
    '退卡成功':'退卡成功','其它会员':'其它会员',
    '新增客户:':'新增客户:','客户新增成功':'客户新增成功',
    '账号：':'账号：','的密码':'的密码','重置密码成功！':'重置密码成功！',
    '当前客户有未完成的会员续期单据，请完成后再发起续期。':'当前客户有未完成的会员续期单据，请完成后再发起续期。',
    '续期成功':'续期成功','续期会员':'续期会员','的有效期':'的有效期',
    '设置账号的下载限制':'设置账号的下载限制',
    '最后登录时间倒序':'最后登录时间倒序','会员过期时间倒序':'会员过期时间倒序','会员创建时间倒序':'会员创建时间倒序',
    '面料折扣': '面料折扣',
    '购买时长': '购买时长',
    '购买金额': '购买金额',
    '店主购买金额': '店主购买金额',
    '所衣折扣': '所衣折扣',
    '饰品折扣': '饰品折扣',
    '辅料折扣': '辅料折扣',
    '可下载数量': '可下载数量',
    '等级名称': '等级名称',
    '成衣定制折扣': '成衣定制折扣',
    '成衣现货折扣': '成衣现货折扣',
    '版型下载数量': '版型下载数量',
    '购买时长(月)': '购买时长(月)',
    '终端客户购买金额': '终端客户购买金额',
    '编辑会员等级': '编辑会员等级',
    '的数据': '的数据',
    '保存成功！': '保存成功！',
    '优惠券设置': '优惠券设置',
    '请录入券名称!': '请录入券名称!',
    '请录入券名称，如双十一活动券。': '请录入券名称，如双十一活动券。',
    '券类型:': '券类型:',
    '请选择券类型!': '请选择券类型!',
    '推荐用户券': '推荐用户券',
    '活动券': '活动券',
    '用户券': '用户券',
    '核销对象:': '核销对象:',
    '请录入核销对象!': '请录入核销对象!',
    '受众范围:': '受众范围:',
    '请录入受众范围!': '请录入受众范围!',
    '使用门槛:': '使用门槛:',
    '请录入使用门槛!': '请录入使用门槛!',
    '请录入券的最低使用门槛金额。': '请录入券的最低使用门槛金额。',
    '券面金额:': '券面金额:',
    '请录入券面金额!': '请录入券面金额!',
    '请录入券面金额。': '请录入券面金额。',
    '券有效期:': '券有效期:',
    '请录入券有效时间范围!': '请录入券有效时间范围!',
    '开始日期': '开始日期',
    '结束日期': '结束日期',
    '所有券清单': '所有券清单',
    '停用': '停用',
    '设置': '设置',
    '确定要删除当前券吗，删除后不可恢复？': '确定要删除当前券吗，删除后不可恢复？',
    '券已过期': '券已过期',
    '消费金额超过': '消费金额超过',
    '已发券清单': '已发券清单',
    '发放券': '发放券',
    '未设': '未设',
    '最近一个月未登录': '最近一个月未登录',
    '最近两个月未登录': '最近两个月未登录',
    '最近三个月未登录': '最近三个月未登录',
    '半年未登录': '半年未登录',
    '最近一个月未下单': '最近一个月未下单',
    '最近两个月未下单': '最近两个月未下单',
    '最近三个月未下单': '最近三个月未下单',
    '半年未下单': '半年未下单',
    '会员数:': '会员数:',
    '不重复发放': '不重复发放',
    '券名称': '券名称',
    '发放': '发放',
    '定向生效': '定向生效',
    '生效周期': '生效周期',
    '券面金额': '券面金额',
    '受众范围': '受众范围',
    '使用门槛': '使用门槛',
    '开始时间': '开始时间',
    '截止时间': '截止时间',
    '过期时间': '过期时间',
    '累计订单': '累计订单',
    '最后下单时间': '最后下单时间',
    '客户': '客户',
    '来源': '来源',
    '发放类型': '发放类型',
    '发生时间': '发生时间',
    '新增优惠券': '新增优惠券',
    '券类型': '券类型',
    '导出': '导出',
    '订单列表': '订单列表',
    '支付宝支付': '支付宝支付',
    '线下支付': '线下支付',
    '余额支付': '余额支付',
    '退款': '退款',
    '确定要作废这个订单吗？': '确定要作废这个订单吗？',
    '作废': '作废',
    '客户分组': '客户分组',
    '订单详情': '订单详情',
    '客户信息': '客户信息',
    '客户姓名': '客户姓名',
    '联系电话': '联系电话',
    '下单时间': '下单时间',
    '版型号': '版型号',
    '数量': '数量',
    '订单金额': '订单金额',
    '券抵扣': '券抵扣',
    '版型退款': '版型退款',
    '退款人': '退款人',
    '退款时间': '退款时间',
    '留言': '留言',
    '购买尺码': '购买尺码',
    '尺码数据': '尺码数据',
    '电话': '电话',
    '商品名称': '商品名称',
    '附件': '附件',
    '尺码': '尺码',
    '评分': '评分',
    '店面信息': '店面信息',
    '订单数量': '订单数量',
    '门店信息': '门店信息',
    '电子版型订单': '电子版型订单',
    '的订单': '的订单',
    '复制成功': '复制成功',
    '无': '无',
    '订单作废成功！': '订单作废成功！',
    '管理员版型退款': '管理员版型退款',
    '退款成功': '退款成功',
    '全部': '全部',
    '客户姓名/手机号/订单号': '客户姓名/手机号/订单号',
    '请输入编码、系统编码、版型标题查询': '请输入编码、系统编码、版型标题查询',
  '服装类别': '服装类别',
  '版型/定制': '版型/定制',
  '添加版型': '添加版型',
  '版型列表': '版型列表',
  '版型共享': '版型共享',
  '全选': '全选',

  '点击开通成衣量体定制': '点击开通成衣量体定制',

  '点击修改量体定制价格': '点击修改量体定制价格',
  '下载版型': '下载版型',
  '所有面料饰品': '所有面料饰品',
  '没有绑定面料或饰品': '没有绑定面料或饰品',
  '面料饰品': '面料饰品',
  '制版师机构列表': '制版师机构列表',
  '提交': '提交',
  '颜色：': '颜色：',
  '成衣定制上下架': '成衣定制上下架',
  '恢复': '恢复',
  '已删除': '已删除',
  '面料名称': '面料名称',
  '面料名称：': '面料名称：',
  '请录入面料名称!': '请录入面料名称!',
  '请引用面料  →': '请引用面料  →',
  '引用面料': '引用面料',
  '面料颜色：': '面料颜色：',
  '请引用面料': '请引用面料',
  '面料款号：': '面料款号：',
  '请录入面料款号!': '请录入面料款号!',
  '成衣定制标题：': '成衣定制标题：',
  '请录入成衣成衣定制标题!': '请录入成衣成衣定制标题!',
  '成衣生产加工费：': '成衣生产加工费：',
  '客户定制成衣价：': '客户定制成衣价：',
  '会员定制成衣价：': '会员定制成衣价：',
  '成衣定制说明：': '成衣定制说明：',
  '请录入成衣描述!': '请录入成衣描述!',
  '请在此录入成衣定制描述': '请在此录入成衣定制描述',
  '新增面料': '新增面料',
  '版型组套': '版型组套',
  '请输入版型标题，代码进行检索': '请输入版型标题，代码进行检索',
  '版型类别': '版型类别',
  '审核还未开始，暂无数据。': '审核还未开始，暂无数据。',
  '版型浏览': '版型浏览',
  '版型基本信息': '版型基本信息',
  '版型标题': '版型标题',
  '版型款号': '版型款号',
  '版型价格': '版型价格',
  '服装分类': '服装分类',
  '版型描述': '版型描述',
  '成衣描述': '成衣描述',
  '版型图片': '版型图片',
  '版型文件': '版型文件',
  '面料信息': '面料信息',
  '面料': '面料',
  '配饰信息': '配饰信息',
  '配饰': '配饰',
  '流程浏览': '流程浏览',
  '电子版型': '电子版型',
  '绑定': '绑定',
  '恢复成功': '恢复成功',
  '开通成功！': '开通成功！',
  '只有开通了成衣定制了才能上下架产品。': '只有开通了成衣定制了才能上下架产品。',
  '账号已停用或绑定错误。': '账号已停用或绑定错误。',
  '提交共享成功': '提交共享成功',
  '新面料': '新面料',
  '饰品名称:': '饰品名称:',
  '请录入饰品名称!': '请录入饰品名称!',
  '饰品颜色:': '饰品颜色:',
  '请录入饰品颜色!': '请录入饰品颜色!',
  '饰品款号:': '饰品款号:',
  '请录入饰品款号!': '请录入饰品款号!',
  '饰品类别:': '饰品类别:',
  '请选择饰品类别!': '请选择饰品类别!',
  '成本价格:': '成本价格:',
  '请录入商品成本价格!': '请录入商品成本价格!',
  '分销价格:': '分销价格:',
  '请录入商品分销价格!': '请录入商品分销价格!',
  '销售价格:': '销售价格:',
  '请录入商品销售价格!': '请录入商品销售价格!',
  '会员价格:': '会员价格:',
  '请录入商品会员价格!': '请录入商品会员价格!',
  '销售单位:': '销售单位:',
  '请录入销售单位!': '请录入销售单位!',
  '商品描述:': '商品描述:',
  '请录入商品描述!': '请录入商品描述!',
  '请在此录入商品描述': '请在此录入商品描述',
  '单击选择': '单击选择',
  '一个或多个文件上传': '一个或多个文件上传',
  '上传的文件将按文件扩展自动分类': '上传的文件将按文件扩展自动分类',
  '图片文件': '图片文件',
  '商品信息': '商品信息',
  '保存': '保存',
  '审核受理中，不可编辑': '审核受理中，不可编辑',
  '已审核,不可编辑': '已审核,不可编辑',
  '保存并提交审核': '保存并提交审核',
  '解除审核': '解除审核',
  '撤销审核申请': '撤销审核申请',
  '返回': '返回',
  '解锁成功': '解锁成功',
  '撤销成功': '撤销成功',
  '撤销失败,当前状态不能被撤销。': '撤销失败,当前状态不能被撤销。',
  '当前账号没有该权限，请联系管理理员': '当前账号没有该权限，请联系管理理员',
  '图片删除成功': '图片删除成功',
  '审核通过。': '审核通过。',
  '提交成功': '提交成功',
  '饰品新增成功': '饰品新增成功',
  '饰品保存成功': '饰品保存成功',
  '请输入编码、系统编码、饰品标题查询': '请输入编码、系统编码、饰品标题查询',
  '商品共享': '商品共享',
  '共享': '共享',
  '不共享': '不共享',
  '饰品范围': '饰品范围',
  '所有饰品': '所有饰品',
  '上级饰品': '上级饰品',
  '本店饰品': '本店饰品',
  '批量上下架': '批量上下架',
  '查询': '查询',
  '添加饰品': '添加饰品',
  '缩图': '缩图',
  '平台编号': '平台编号',
  '款号': '款号',
  '状态': '状态',
  '标题': '标题',
  '颜色': '颜色',
  '库存数': '库存数',
  '销售价': '销售价',
  '所属门店': '所属门店',
  '上下架时间': '上下架时间',
  '最后修改人': '最后修改人',
  '操作': '操作',
  '修改上架时间': '修改上架时间',
  '确定': '确定',
  '取消': '取消',
  '待审核': '待审核',
  '已审核': '已审核',
  '已驳回': '已驳回',
  '审核中': '审核中',
  '上架平台': '上架平台',
  '未通过': '未通过',
  '下架平台': '下架平台',
  '上架': '上架',
  '下架': '下架',
  '编辑': '编辑',
  '查看': '查看',
  '删除': '删除',
  '加颜色': '加颜色',
  '设为头版': '设为头版',
  '添加饰品颜色': '添加饰品颜色',
  '饰品标题:': '饰品标题:',
  '请录入饰品标题!': '请录入饰品标题!',
  '饰品编号:': '饰品编号:',
  '饰品单位:': '饰品单位:',
  '请录入PLT文件价格!': '请录入PLT文件价格!',
  '请录入成本价格!': '请录入成本价格!',
  '请录入销售价格!': '请录入销售价格!',
  '确定删除该图片吗？': '确定删除该图片吗？',
  '请选择需要添加的版型。': '请选择需要添加的版型。',
  '审核详情': '审核详情',
  '审核尚未开始': '审核尚未开始',
  '不通过': '不通过',
  '通过': '通过',
  '原因：': '原因：',
  '审核附件': '审核附件',
  '关闭': '关闭',
  '引用': '引用',
  '标题：': '标题：',
  '请录入版型标题：!': '请录入版型标题：!',
  '销售价：': '销售价：',
  '会员价：': '会员价：',
  '分销价：': '分销价：',
  '版型说明：': '版型说明：',
  '请在入版型描述!': '请在入版型描述!',
  '请在此录入版型描述': '请在此录入版型描述',
  '更新': '更新',
  '删除商品': '删除商品',
  '您确认删除该商品吗？删除后不可恢复！！': '您确认删除该商品吗？删除后不可恢复！！',
  '请勾选需要批量上下架的产品': '请勾选需要批量上下架的产品',
  '上级店面的商品': '上级店面的商品',
  '自已创建的商品': '自已创建的商品',
  '批量上架': '批量上架',
  '批量下架': '批量下架',
  '删除成功！': '删除成功！',
  '设置封面成功。': '设置封面成功。',
  '操作成功': '操作成功',
  '面料标题:': '面料标题:',
  '请录入面料标题!': '请录入面料标题!',
  '面料颜色:': '面料颜色:',
  '请录入面料颜色!': '请录入面料颜色!',
  '面料编号:': '面料编号:',
  '面料单位:': '面料单位:',
  '请输入编码、系统编码、成衣标题查询': '请输入编码、系统编码、成衣标题查询',
  '面料范围': '面料范围',
  '所有面料': '所有面料',
  '上级面料': '上级面料',
  '本店面料': '本店面料',
  '添加面料': '添加面料',
  '创建组套': '创建组套',
  '保存组套': '保存组套',
  '取消组套': '取消组套',
  '绑定成衣': '绑定成衣',
  '添加面料颜色': '添加面料颜色',
  '输入关键字查询成衣': '输入关键字查询成衣',
  '编号': '编号',
  '上架时间': '上架时间',
  '成衣组套': '成衣组套',
  '输入编号标题开始查询': '输入编号标题开始查询',
  '选择': '选择',
  '确认组套': '确认组套',
  '宽度': '宽度',
  '米': '米',
  '解套': '解套',
  '组套': '组套',
  '确认绑定': '确认绑定',
  '下一步': '下一步',
  '上一步': '上一步',
  '删除成功': '删除成功',
  '共享成功': '共享成功',
  '取消共享成功': '取消共享成功',
  '设置成功。': '设置成功。',
  '版型更新成功': '版型更新成功',
  '面料新增成功': '面料新增成功',
  '请录入正确的价格!': '请录入正确的价格!',
  '元': '元',
  '博克CAD-PLT-尺码文件': '博克CAD-PLT-尺码文件',
  '打包下载': '打包下载',
  '版型信息': '版型信息',
  '绑定面料': '绑定面料',
  '绑定配饰': '绑定配饰',
  '上传的EXCEL尺码与所选择的尺码类型不匹配': '上传的EXCEL尺码与所选择的尺码类型不匹配',
  '尺码匹配错误': '尺码匹配错误',
  '缺失': '缺失',
  '忽略': '忽略',
  '正在下载文件中，请稍后……': '正在下载文件中，请稍后……',
  '尺码更新成功': '尺码更新成功',
  '当前账号没有编辑权限，请联系管理员。': '当前账号没有编辑权限，请联系管理员。',
  '文件删除成功': '文件删除成功',
  '已存在，不能重复添加': '已存在，不能重复添加',
  '上传失败': '上传失败',
  '尺码数据匹配错误，请修改后再保存！': '尺码数据匹配错误，请修改后再保存！',
  '版型新增成功': '版型新增成功',
  '版型保存成功': '版型保存成功',
  '版型保存失败': '版型保存失败',
  '面料商:': '面料商:',
  '运单信息:': '运单信息:',
  '运单号:': '运单号:',
  '服装标题:': '服装标题:',
  '请录入服装标题!': '请录入服装标题!',
  '服装款号:': '服装款号:',
  '请录入服装编号!': '请录入服装编号!',
  'PLT文件价格:': 'PLT文件价格:',
  '版型分销价格:': '版型分销价格:',
  '服装风格:': '服装风格:',
  '服装分类:': '服装分类:',
  '尺码类型:': '尺码类型:',
  '请选择尺码表类别': '请选择尺码表类别',
  '适应季节:': '适应季节:',
  '春': '春',
  '夏': '夏',
  '秋': '秋',
  '冬': '冬',
  '版型调整视频:': '版型调整视频:',
  '上传视频': '上传视频',
  '浏览视频': '浏览视频',
  '动态短视频:': '动态短视频:',
  '请录入动态短视频!': '请录入动态短视频!',
  '版型描述:': '版型描述:',
  '请录入录入版型描述!': '请录入录入版型描述!',
  '查看视频': '查看视频',
  '上下架': '上下架',
  '是否共享': '是否共享',
  '平台售卖': '平台售卖',
  '服装版型': '服装版型',
  '成衣定制': '成衣定制',
  '该产品处于上架中，不可删除！': '该产品处于上架中，不可删除！',
  '该产品处于共享中，不可删除！': '该产品处于共享中，不可删除！',
  '请先删除子项！': '请先删除子项！',
  '只有审核通过的产品才能上架产品。': '只有审核通过的产品才能上架产品。',
  '该产品已停止共享，暂不可上架！': '该产品已停止共享，暂不可上架！',
  '原店面已将该产品下架，暂不可上架！': '原店面已将该产品下架，暂不可上架！',
  '上架成功！': '上架成功！',
  '下架成功！': '下架成功！',
  '平台上架提交成功。': '平台上架提交成功。',
  '平台上架取消成功。': '平台上架取消成功。',
  '已完成{0}个产品的上架操作。': '已完成{0}个产品的上架操作。',
  '已完成{0}个产品的下架操作。': '已完成{0}个产品的下架操作。',
  '成组成功': '成组成功',
  '请至少勾选两个项目进行组套！': '请至少勾选两个项目进行组套！',
  '取消成组成功。': '取消成组成功。',
  '解套成功。': '解套成功。',
  '绑定成功': '绑定成功',
  '当前版型已经绑定了其它成衣，不再能再次绑定了。': '当前版型已经绑定了其它成衣，不再能再次绑定了。',
  '绑定失败': '绑定失败',
  '解绑成功': '解绑成功',
  '分类': '分类',
  '图片': '图片',
  'PLT价': 'PLT价',
  'BOKE价': 'BOKE价',
  '客户取货方式': '客户取货方式',
    '邮寄': '邮寄',
    '收货地址': '收货地址',
    '顺丰ID': '顺丰ID',
    '物流信息': '物流信息',
    '物流公司': '物流公司',
    '发货': '发货',
    '收货人': '收货人',
    '收货人电话': '收货人电话',
    '联系方式': '联系方式',
    '售后订单': '售后订单',
    '预售订单': '预售订单',
    '详情': '详情',
    '处理': '处理',
    '待接收订单': '待接收订单',
    '已接收订单': '已接收订单',
    '手动派单': '手动派单',
    '平台版师': '平台版师',
    '入驻版师': '入驻版师',
    '支付时间': '支付时间',
    '商品退款': '商品退款',
    '邮寄费用': '邮寄费用',
    '退邮寄费': '退邮寄费',
    '券减免': '券减免',
    '售后事项': '售后事项',
    '退款商品': '退款商品',
    '货物状态': '货物状态',
    '退款原因': '退款原因',
    '退款金额': '退款金额',
    '相关图片': '相关图片',
    '同意退款': '同意退款',
    '拒绝退款': '拒绝退款',
    '签收货物': '签收货物',
    '确认签收': '确认签收',
    '确认退款': '确认退款',
    '确定要作废这个订单吗': '确定要作废这个订单吗',
    '视频安装': '视频安装',
    '安装时间': '安装时间',
    '安装人': '安装人',
    '安装状态': '安装状态',
    '安装备注': '安装备注',
    '请选择安装时间': '请选择安装时间',
    '请选择安装人': '请选择安装人',
    '请选择安装状态': '请选择安装状态',
    '课程退款': '课程退款',
    '课程名称': '课程名称',
    '支付并开通': '支付并开通',
    '修改价格': '修改价格',
    '原始订单金额': '原始订单金额',
    '新订单金额': '新订单金额',
    '已开通': '已开通',
    '已提交': '已提交',
    '已支付': '已支付',
    '已作废': '已作废',
    '刷新': '刷新',
    '当前没有未派送的订单': '当前没有未派送的订单',
    '成衣图片': '成衣图片',
    '客户体型': '客户体型',
    '暂无客户体型图片': '暂无客户体型图片',
    '饰品信息': '饰品信息',
    '抢单': '抢单',
    '自动匹配': '自动匹配',
    '撤销更改': '撤销更改',
    '保存量体尺码': '保存量体尺码',
    '正在下载文件中请稍后': '正在下载文件中，请稍后……',
    '加载中': '加载中……',
    '下载当前客户版型': '下载当前客户版型',
    '下载团体客户版型': '下载团体客户版型',
    '产品标题': '产品标题',
    '下载': '下载',
    '成衣型号': '成衣型号',
    '售后状态': '售后状态',
    '订单状态': '订单状态',
    '退款发起日期': '退款发起日期',
    '货运信息': '货运信息',
    '面料号': '面料号',
    '饰品号': '饰品号',
    '我的订单': '我的订单',
    '专属版型': '专属版型',
    '新增订单': '新增订单',
    '纸质版型': '纸质版型',
    '线下量体': '线下量体',
    '下载团体客户数据': '下载团体客户数据',
    '面料订单': '面料订单',
    '辅料订单': '辅料订单',
    '账户支付': '账户支付',
    '已取件': '已取件',
    '运输中': '运输中',
    '已签收': '已签收',
    '已发货': '已发货',
    '待发货': '待发货',
    '多状态': '多状态',
    '运单号': '运单号',
    '送至': '送至',
    '设置顺丰ID': '设置顺丰ID',
    '请录入顺丰ID': '请录入顺丰ID',
    '邮费': '邮费',
    '打印费': '打印费',
    '退打印费': '退打印费',
    '已完成打印': '完成打印',
    '已打印': '已打印',
    '打印': '打印',
    '订单已发货': '订单已发货！',
    '版型已打印': '版型已打印！',
    '未收到货': '未收到货',
    '已收到货': '已收到货',
    '不想要了': '不想要了',
    '协商一致退款': '协商一致退款',
    '空包裹': '空包裹',
    '快递一直未送到': '快递一直未送到',
    '商品破损已拒签': '商品破损已拒签',
    '客户申请退货退款': '客户申请退货退款',
    '买家退货': '买家退货',
    '退款完毕': '退款完毕',
    '客户寄回货物': '客户寄回货物',
    '商家同意退货': '商家同意退货',
    '等待接收退货说明': '等待接收客户退回的货物，收到货后确认签收即可完成退款。',
    '商家拒绝退货': '商家拒绝退货',
    '拒绝原因': '拒绝原因',
    '回复时间': '回复时间',
    '商家已退款': '商家已退款',
    '退款成功时间': '退款成功时间',
    '请录入拒绝原因': '请录入拒绝原因',
    '确认签收并退款': '确认签收并退款',
    '确认签收提示': '您确认收到退回货物了吗，点击确认后将向客户退回货款',
    '确认退款提示': '当前订单未发货，将退回总金额',
    '您确认退款吗': '您确认退款吗？',
    '收件人': '收件人：',
    '收件人电话': '收件人电话：',
    '收件地址': '收件地址：',
    '物流信息标签': '物流信息：',
    '原订单号': '原订单号：',
    '商品货号': '商品货号：',
    '退款失败': '退款失败',
    '全部门店': '全部门店',
    '自营平台': '自营平台',
    '重置': '重置',
    '批次号': '批次号',
    '量体类型': '量体类型',
    '下载个人': '下载个人',
    '下载团体': '下载团体',
    '打印清单': '打印清单',
    '收件人标签': '收件人',
    '联系电话标签': '联系电话',
    '收件地址标签': '收件地址',
    '购买版型': '购买版型',
    '购买尺码标签': '购买尺码',
    '微信扫码查看小程序': '微信扫码查看小程序',
    '微信扫码联系客服': '微信扫码联系客服',
    '微信扫码查看细节': '微信扫码查看细节',
    '面料生产提示': '因不同属性面料料性差别大，为保证成品效果，请选择相似\\相近面料生产成衣。',
    '电话标签': '电话',
    '网址': '网址',
    '总接单': '总接单:',
    '今接单': '今接单:',
    '总': '总',
    '今': '今',
    '请选择需要回复的信息': '请选择需要回复的信息',
    '输入消息内容': '输入消息内容',
    '请输入金额': '请输入金额',
    '发送': '发送',
    '出价': '出价',
    '咨询': '咨询',
    '企微': '企微',
    '结束': '结束',
    '是否继续': '当前操作会关闭当前售后订单，是否继续？',
    '是': '是',
    '否': '否',
    '订单已确认等待付款': '订单已确认，等待客户付款。',
    '订单已付款等待发布': '订单已付款，等待版师发布版型。',
    '请选择待派送订单': '请选择待派送订单！',
    '请输入物流单号': '请输入物流单号',
    '定制图片': '定制图片',
    '定制尺码': '定制尺码',
    '上传附件': '上传附件',
    '请将BOKE文件打包上传': '请将BOKE文件+尺码文件+PLT文件打包上传',
    '购买版型按钮': '购买版型',
    '线下预约量体': '线下预约量体',
    '面料商': '面料商',
    '金额': '金额',
    '公司': '公司',
    '生产商': '生产商',
    '成衣生产商': '成衣生产商',
    '输入生产商': '输入生产商',
    '总接单数': '总接单数:',
    '今日接单': '今日接单:',
    '待发货标签': '待发货',
    '到店自取': '到店自取',
    '物流': '物流：',
    '单号': '单号：',
    '查看详情': '查看详情',
    '接收订单': '接收订单',
    '确定要撤回这个订单吗': '确定要撤回这个订单吗？',
    '撤回': '撤回',
    '加工费/生产商': '加工费/生产商',
    '订单来源': '订单来源',
    '订单信息': '订单信息',
    '版型类型': '版型类型',
    '价格': '价格',
    '总金额': '总金额',
    '名称': '名称',
    '在线下载': '在线下载',
    '相同地址合并发货': '相同地址合并发货',
    '联系地址': '联系地址',
    '点击查看详情': '点击查看详情',
    '点击上传版型': '点击上传版型',
    '点击删除已上传的版型文件': '点击删除已上传的版型文件',
    '点击下载订单文件': '点击下载订单文件',
    '已退款': '已退款',
    '版型费': '版型费',
    '纸质版型订单': '纸质版型订单',
    '快递商': '快递商',
    '打印清单提示': '打印清单',
    '请输入需要下载的内容': '正在下载文件中，请稍后……',
    '开通成功提示': '开通成功，请通知会员退出重新登录后生效',
    '请选择需要开通的会员订单': '请选择需要开通的会员订单',
    '该订单已支付不能修改': '该订单已支付，不能修改',
    '修改成功': '修改成功',
    '订单已分配提示': '订单已分配生产商，无需重复分配',
    '您已成功接单': '您已成功接单',
    '订单未付款不能发货': '订单未付款，不能发货',
    '订单已退款不能发货': '订单已退款，不能发货',
    '订单已作废不能发货': '订单已作废，不能发货',
    '请填写物流信息': '请填写物流信息',
    '订单已发货提示': '订单已发货',
    '正在下载文件中': '正在下载文件中，请稍后……',
    '售后退款': '售后退款',
    '退回': '退回',
    '生产商统一提供': '生产商统一提供',
    '请输入生产商': '输入生产商',
    '客户姓名手机号订单号': '客户姓名/手机号/订单号',
    '智能量体订单': '智能量体订单',
    '匹配范围': '匹配范围',
    '运费': '运费',
    '成衣预售订单': '成衣预售订单',
    '缺少收件人信息': '缺少收件人信息',
    '订单作废成功': '订单作废成功！',
    '请选择是否同意退款': '请选择是否同意退款！',
    '售后退款标签': '售后退款',
    '后台退款备注': '后台退款，备注：',
    '成衣现货订单': '成衣现货订单',
    '高震服装设计': '高震服装设计',
    '分店': '分店',
    '饰品退款': '饰品退款',
    '邮寄费': '邮寄费',
    '设计师': '设计师',
    '接单时间': '接单时间',
    '发起时间': '发起时间',
    '服务时间': '服务时间',
    '加码订单号': '加码订单号',
    '点击复制': '点击复制',
    '点击下载': '点击下载',
    '未打印': '未打印',
    '回复内容不能为空': '回复内容不能为空！',
    '没有发现售后订单': '没有发现售后订单',
    '派单成功': '派单成功！',
    '该机构当日接单数量已超限': '该机构当日接单数量已超限，不能再接单了。',
    '账号已停用或绑定错误': '账号已停用或绑定错误。',
    '请设置发货人信息': '请设置发货人信息',
    '上传成功': '上传成功',
    '的订单已发货': '的订单已发货！',
    '饰品订单': '饰品订单',
    '量体定制订单': '量体定制订单',
    '输入': '输入',
    '自动匹配，匹配范围：': '自动匹配，匹配范围：',
    '已退款标签': '已退款',
    '退款商品:': '退款商品:',
    '货物状态:': '货物状态:',
    '退款原因:': '退款原因:',
    '退款金额:': '退款金额:',
    '退款说明:': '退款说明:',
    '相关图片:': '相关图片:',
    '会员开通支付订单': '会员开通支付订单',
    '支付金额': '支付金额',
    '操作人': '操作人',
    '订单时间': '订单时间',
    '操作时间': '操作时间',
    '订单类别': '订单类别',
    '优惠金额': '优惠金额',
    '客户名称': '客户名称',
    '升级级别': '升级级别',
    '级别周期': '级别周期',
    '级别结束时间': '级别结束时间',
    '可下载次数': '可下载次数',
    '平台金额': '平台金额',
    '待向平台支付并开通会员': '待向平台支付并开通会员',
    '价格修改记录': '价格修改记录',
    '修改人': '修改人',
    '修改时间': '修改时间',
    '会员下单': '会员下单',
    '会员升级充值订单': '会员升级充值订单',
    '级别开始时间': '级别开始时间',
    '】码新增成功': '】码新增成功',
    
    一键引用: '一键引用',
    
    上平台: '上平台',
    上平台售卖审核: '上平台售卖审核',
    
    上级成衣: '上级成衣',
    上级版型: '上级版型',
    上级辅料: '上级辅料',
    
    '个产品的上架操作。': '个产品的上架操作。',
    '个产品的下架操作。': '个产品的下架操作。',
    二级分店: '二级分店',
    '二级分店:': '二级分店:',
    产品类别: '产品类别',
    会员价: '会员价',
    '会员价:': '会员价:',
    会员价格: '会员价格',
    
    供应商列表: '供应商列表',
    
    保存绑定: '保存绑定',
    
    修改为: '修改为',
    修改密码: '修改密码',
    修改成衣量体定制价格: '修改成衣量体定制价格',
    修改成衣颜色: '修改成衣颜色',
    修改订单价格: '修改订单价格',
    修改记录: '修改记录',
    
    全不选: '全不选',
    
    分店上下架: '分店上下架',
    分店代码: '分店代码',
    分店分销至其它分店: '分店分销至其它分店',
    分店名称: '分店名称',
    
    分销价: '分销价',
    分销价格: '分销价格',
    
    分销数: '分销数',
    
    删除引用: '删除引用',
    
    加码: '加码',
    
    单位: '单位',
    
    博克文件价格: '博克文件价格',
    原价: '原价',
    
    原始密码: '原始密码',
    
    原订单价格: '原订单价格',
    
    品牌名称: '品牌名称',
    商品价格: '商品价格',
    
    商品分类: '商品分类',
    商品图片: '商品图片',
    商品基本信息: '商品基本信息',
    商品描述: '商品描述',
    
    商品标题: '商品标题',
    商品款号: '商品款号',
    商品类别: '商品类别',
    商品详情: '商品详情',
    
    审核不通过: '审核不通过',
    
    '审核人：': '审核人：',
    审核受理中不可编辑: '审核受理中不可编辑',
    
    审核时间: '审核时间',
    审核结果: '审核结果',
    审核记录: '审核记录',
    
    审核通过: '审核通过',
    
    小程序APPID: '小程序APPID',
    小程序Secret: '小程序Secret',
    
    尺码类型: '尺码类型',
    
    '尺码表类别:': '尺码表类别:',
    
    已完成: '已完成',
    
    已审核不可编辑: '已审核不可编辑',
    已引用: '已引用',
    已绑定面料: '已绑定面料',
    
    平台成衣: '平台成衣',
    平台版型库: '平台版型库',
    
    平台辅料: '平台辅料',
    平台面料: '平台面料',
    平台饰品: '平台饰品',
    
    开启预售: '开启预售',
    '开启预售:': '开启预售:',
    开放时间: '开放时间',
    开通: '开通',
    
    开通成衣量体定制: '开通成衣量体定制',
    开通指引: '开通指引',
    
    待确认: '待确认',
    微信支付公钥ID: '微信支付公钥ID',
    微信支付公钥文件: '微信支付公钥文件',
    微信支付参数获取指引: '微信支付参数获取指引',
    微信支付商户ID: '微信支付商户ID',
    微信支付密钥: '微信支付密钥',
    微信支付证书: '微信支付证书',
    微信支付证书号: '微信支付证书号',
    微信服务号APPID: '微信服务号APPID',
    
    成本价: '成本价',
    成本价格: '成本价格',
    
    成衣: '成衣',
    '成衣【': '成衣【',
    成衣信息: '成衣信息',
    
    '成衣描述:': '成衣描述:',
    成衣标题: '成衣标题',
    成衣款号: '成衣款号',
    成衣添加尺码: '成衣添加尺码',
    
    '成衣生产成本价：': '成衣生产成本价：',
    
    成衣范围: '成衣范围',
    成衣预售: '成衣预售',
    
    所有成衣: '所有成衣',
    所有版型: '所有版型',
    所有辅料: '所有辅料',
    
    扫码绑定成功: '扫码绑定成功',
    
    批量引用平台版型: '批量引用平台版型',
    指导价: '指导价',
    
    改价: '改价',
    
    文件大小不能超过2M: '文件大小不能超过2M',
    
    新密码: '新密码',
    
    无法修改价格: '无法修改价格',
    时间: '时间',
    
    '是否上架:': '是否上架:',
    
    '是否共享给平台:': '是否共享给平台:',
    是否引用: '是否引用',
    昵称: '昵称',
    暂无面料: '暂无面料',
    暂无饰品: '暂无饰品',
    
    '最晚发货时间:': '最晚发货时间:',
    最晚发货时间不能早于预售时间: '最晚发货时间不能早于预售时间',
    
    服装定制: '服装定制',
    服装尺码: '服装尺码',
    '服装尺码:': '服装尺码:',
    服装标题: '服装标题',
    
    服装编号: '服装编号',
    '服装编号:': '服装编号:',
    '服装配饰:': '服装配饰:',
    '服装面料:': '服装面料:',
    '服装颜色:': '服装颜色:',
    服装风格: '服装风格',
    
    '服装饰品:': '服装饰品:',
    未引用: '未引用',
    
    本店成衣: '本店成衣',
    本店版型: '本店版型',
    本店辅料: '本店辅料',
    
    来源门店: '来源门店',
    
    正在生成二维码: '正在生成二维码',
    
    浏览: '浏览',
    
    添加: '添加',
    添加二级分销分店: '添加二级分销分店',
    添加分店: '添加分店',
    添加成衣: '添加成衣',
    添加成衣颜色: '添加成衣颜色',
    
    添加辅料: '添加辅料',
    添加辅料颜色: '添加辅料颜色',
    
    点击确定开始引用平台产品: '点击确定开始引用平台产品',
    版型: '版型',
    
    版型上架: '版型上架',
    版型上架时间: '版型上架时间',
    
    版型分销价格: '版型分销价格',
    
    版型定制: '版型定制',
    
    '生产尺码:': '生产尺码:',
    '生产面料:': '生产面料:',
    申请时间: '申请时间',
    申请详情: '申请详情',
    申请门店: '申请门店',
    
    登录账号: '登录账号',
    
    确定引用: '确定引用',
    确认删除该引用吗: '确认删除该引用吗',
    '确认删除该引用吗，一旦删除产品将会自动下架，相关订单也会受到影响，确认删除吗？': '确认删除该引用吗，一旦删除产品将会自动下架，相关订单也会受到影响，确认删除吗？',
    确认并上架: '确认并上架',
    
    绑定公众号: '绑定公众号',
    绑定公众号接收消息提醒: '绑定公众号接收消息提醒',
    
    绑定微信公众号: '绑定微信公众号',
    
    绑定成衣数: '绑定成衣数',
    绑定版型: '绑定版型',
 
    绑定饰品: '绑定饰品',
    '结果：': '结果：',

    订单状态为: '订单状态为',

    设置封面: '设置封面',

 
    '该成衣所有尺码均已添加，无需再加码。': '该成衣所有尺码均已添加，无需再加码。',
    '请勾选成衣尺码!': '请勾选成衣尺码!',
    请在此录入成衣描述: '请在此录入成衣描述',
    请在此录入辅料描述: '请在此录入辅料描述',
    请在此录入面料描述: '请在此录入面料描述',
    请录入会员价格: '请录入会员价格',
    '请录入会员价格!': '请录入会员价格!',
    请录入分销价格: '请录入分销价格',
    '请录入分销价格!': '请录入分销价格!',
    请录入制作价格: '请录入制作价格',
    '请录入制作价格!': '请录入制作价格!',
    请录入原始密码: '请录入原始密码',
    请录入商户ID: '请录入商户ID',
    请录入微信支付密钥: '请录入微信支付密钥',
    请录入成本价格: '请录入成本价格',
    请录入成衣款号: '请录入成衣款号',
    请录入最晚发货时间: '请录入最晚发货时间',
    请录入服务号APPID: '请录入服务号APPID',
    请录入服装分类: '请录入服装分类',
    '请录入服装分类!': '请录入服装分类!',
    请录入服装尺码: '请录入服装尺码',
    请录入服装标题: '请录入服装标题',
    '请录入服装颜色!': '请录入服装颜色!',
    请录入服装风格: '请录入服装风格',
    请录入证书: '请录入证书',
    请录入辅料会员价格: '请录入辅料会员价格',
    请录入辅料分销价格: '请录入辅料分销价格',
    请录入辅料名称: '请录入辅料名称',
    请录入辅料成本价格: '请录入辅料成本价格',
    请录入辅料描述: '请录入辅料描述',
    '请录入辅料标题!': '请录入辅料标题!',
    请录入辅料款号: '请录入辅料款号',
    请录入辅料销售价格: '请录入辅料销售价格',
    '请录入辅料颜色!': '请录入辅料颜色!',
    请录入销售单位: '请录入销售单位',
    请录入面料会员价格: '请录入面料会员价格',
    请录入面料分类: '请录入面料分类',
    请录入面料分销价格: '请录入面料分销价格',
    请录入面料单位: '请录入面料单位',
    请录入面料名称: '请录入面料名称',
    请录入面料宽度: '请录入面料宽度',
    请录入面料成本价格: '请录入面料成本价格',
    请录入面料描述: '请录入面料描述',

    请录入面料款号: '请录入面料款号',
    请录入面料销售价格: '请录入面料销售价格',
    请录入面料颜色: '请录入面料颜色',
    请录入预售时间: '请录入预售时间',
    '请确认是否上架!': '请确认是否上架!',
    '请确认是否共享给平台!': '请确认是否共享给平台!',
    
    请输入款号标题查询: '请输入款号标题查询',
    
    '请输入编码、系统编码、辅料标题查询': '请输入编码、系统编码、辅料标题查询',
    
    请输入编码系统编码成衣标题查询: '请输入编码系统编码成衣标题查询',
    请输入编码系统编码标题查询: '请输入编码系统编码标题查询',
    请输入编码系统编码版型标题查询: '请输入编码系统编码版型标题查询',
    '请选择二级分店!': '请选择二级分店!',
    请选择商品类别: '请选择商品类别',
    
    '请选择服装分类!': '请选择服装分类!',
    请选择需要批量引用的服装类别: '请选择需要批量引用的服装类别',
    
    请选择面料分类: '请选择面料分类',
    
    账号信息: '账号信息',
    
    购买: '购买',
    辅料上架: '辅料上架',
    辅料信息: '辅料信息',
    '辅料单位:': '辅料单位:',
    辅料名称: '辅料名称',
    辅料平台上架: '辅料平台上架',
    辅料描述: '辅料描述',
    辅料新增成功: '辅料新增成功',
    '辅料标题:': '辅料标题:',
    辅料款号: '辅料款号',
    辅料添加颜色: '辅料添加颜色',
    '辅料编号:': '辅料编号:',
    辅料范围: '辅料范围',
    辅料颜色: '辅料颜色',
    '辅料颜色:': '辅料颜色:',
    
    输入关键字查询版型: '输入关键字查询版型',
    
    输入面料商开始筛选: '输入面料商开始筛选',
    
    退出登录: '退出登录',
    适应季节: '适应季节',
    
    选择门店: '选择门店',
    
    销售价格: '销售价格',
    
    销售单位: '销售单位',
    
    销量: '销量',
    门店: '门店',
    零售价: '零售价',
    
    面料下架: '面料下架',
    
    面料分类: '面料分类',
    面料列表: '面料列表',
    面料单位: '面料单位',
    面料宽度: '面料宽度',
    面料描述: '面料描述',
    
    面料查询: '面料查询',
    面料标题: '面料标题',
    
    面料款号: '面料款号',
    
    面料颜色: '面料颜色',
    '订单数':'订单数',
    预估用量: '预估用量',
    预售: '预售',
    预售成衣: '预售成衣',
    '预售时间:': '预售时间:',
    
    风格: '风格',
    
    饰品列表: '饰品列表',
    
    饰品商: '饰品商',    
    饰品查询: '饰品查询',
    开始: '开始',
    添加结点: '添加结点',
    面辅料审核: '面辅料审核',
    共享审核: '共享审核',
    合规性审核: '合规性审核',
    更新审核设置: '更新审核设置',
    审核状态: '审核状态',
    版型成衣选择: '版型成衣选择',

    审核: '审核',
    申请单号: '申请单号',
    申请事项: '申请事项',

    制作价格: '制作价格',
    原因: '原因',
    请录入审核不通过的原因: '请录入审核不通过的原因',
    请选择审核结果: '请选择审核结果',
    审核成功: '审核成功',
    您当前没有待审核的共享版型: '您当前没有待审核的共享版型。',
    您当前没有待审核的面辅料: '您当前没有待审核的面辅料。',
    您当前没有待审核的饰品: '您当前没有待审核的饰品。',
    您当前没有待审核的引用版型: '您当前没有待审核的引用版型。',
    辅料: '辅料',
    面辅料选择: '面辅料选择',
    基本信息: '基本信息',
    产品编号: '产品编号',
    产品描述: '产品描述',
    面料图片: '面料图片',
    饰品基本信息: '饰品基本信息',
    饰品标题: '饰品标题',
    饰品编号: '饰品编号',
    饰品描述: '饰品描述',
    饰品图片: '饰品图片',
    下发门店: '下发门店',
    尺码行数: '尺码行数',
    发布时间: '发布时间',
    智能版型: '智能版型',
    提交时间: '提交时间',
    成衣尺码: '成衣尺码',
    自营: '自营',
    蓝迪云平台: '蓝迪云平台',
    引用审核: '引用审核',
    您当前没有待审核的:'您当前没有待审核的',
    面辅料:'面辅料',
    '未审核': '未审核',
    '已拒绝': '已拒绝',
    '驳回': '驳回',
    '请选择审核结果!': '请选择审核结果!',
    '驳回原因': '驳回原因',
    '请输入驳回原因': '请输入驳回原因',
    '续期开始时间': '续期开始时间',
    '续期结束时间': '续期结束时间',
    '会员续期审核': '会员续期审核',
    '收入类别': '收入类别',
    '会员编号': '会员编号',
    '收入金额': '收入金额',
    '收入项目': '收入项目',
    '项目代码': '项目代码',
    '可用': '可用',
    '新增账户充值信息': '新增账户充值信息',
    '录入充值金额': '录入充值金额',
    '录入说明详情': '录入说明详情',
    '新增成功': '新增成功',
    '客户姓名/手机号': '客户姓名/手机号',
    '总本金金额': '总本金金额',
    '总赠送金额': '总赠送金额',
    '续费周期': '续费周期',
    '付款方式': '付款方式',
    '微信': '微信',
    '支付宝': '支付宝',
    '提现': '提现',
    '待提现': '待提现',
    '已完结': '已完结',
    '执行提现': '执行提现',
    '提现收款账号': '提现收款账号',
    '提现金额': '提现金额',
    '提现申请人': '提现申请人',
    '提现申请时间': '提现申请时间',
    '执行人': '执行人',
    '执行时间': '执行时间',
    '提现状态': '提现状态',
    '执行': '执行',
    '提现账号': '提现账号',
    '开户行': '开户行',
    '账号名称': '账号名称',
    '银行卡号': '银行卡号',
    '提现额度': '提现额度',
    '请线下将钱款打入对方账号后，再进行此操作。': '请线下将钱款打入对方账号后，再进行此操作。',
    '打款完成': '打款完成',
    '提现执地成功': '提现执地成功',
    '全部商品': '全部商品',
    '饰品': '饰品',
    '入库编号': '入库编号',
    '单价': '单价',
    '商品类型': '商品类型',
    '入库数量': '入库数量',
    '最新库存数量': '最新库存数量',
    '入库原因': '入库原因',
    '新进货入库': '新进货入库',
    '盘盈入库': '盘盈入库',
    '其他入库': '其他入库',
    '出库编号': '出库编号',
    '出库数量': '出库数量',
    '出库原因': '出库原因',
    '出库时间': '出库时间',
    '销售出库': '销售出库',
    '盘亏出库': '盘亏出库',
    '损耗出库': '损耗出库',
    '出库': '出库',
    '入库': '入库',
    '出入记录': '出入记录',
    '未上架': '未上架',
    '已上架': '已上架',
    '出入库详情': '出入库详情',
    '手动出库': '手动出库',
    '当前库存数': '当前库存数',
    '输入出库数量': '输入出库数量',
    '选择出库原因': '选择出库原因',
    '添加库存': '添加库存',
    '新入库数量': '新入库数量',
    '输入入库数量': '输入入库数量',
    '选择入库原因': '选择入库原因',
    '其它入库': '其它入库',
    '请输入出库原因！': '请输入出库原因！',
    '请输入出库数量': '请输入出库数量',
    '请输入入库原因！': '请输入入库原因！',
    '请输入入库数量': '请输入入库数量',
    '入库成功': '入库成功',
    '单价(元)': '单价(元)',
    '出入数量': '出入数量',
    '当前数量': '当前数量',
    '操作类型': '操作类型',
    '操作人员': '操作人员',
    '是否启用': '是否启用',
    '站内通知': '站内通知',
    '请录入站内通知!': '请录入站内通知!',
    '站内通知：一行为一条，轮询通知。': '站内通知：一行为一条，轮询通知。',
    '新增类别': '新增类别',
    '辅料分类': '辅料分类',
    '饰品分类': '饰品分类',
    '确定要删除这个项目吗？': '确定要删除这个项目吗？',
    '确定删除': '确定删除',
    '添加子项': '添加子项',
    '使用中': '使用中',
    '父编码': '父编码',
    '录入父编码': '录入父编码',
    '类型名称': '类型名称',
    '录入类型名称': '录入类型名称',
    '排序码': '排序码',
    '录入排序码': '录入排序码',
    '父编号': '父编号',
    '关联数量': '关联数量',
    '最近修改时间': '最近修改时间',
    '新增尺码': '新增尺码',
    '模板名称': '模板名称',
    '蓝迪云尺码': '蓝迪云尺码',
    '加盟商尺码': '加盟商尺码',
    '保留尺码': '保留尺码',
    '被使用数': '被使用数',
    '绑定数量': '绑定数量',
    '关联大类': '关联大类',
    '用途分类': '用途分类',
    '创建人': '创建人',
    '新增分组': '新增分组',
    '导入': '导入',
    '尺码名称': '尺码名称',
    '录入类型简码': '录入类型简码',
    '尺码类别': '尺码类别',
    '尺码分组': '尺码分组',
    '请录入尺码关联大类': '请录入尺码关联大类',
    '版型系统': '版型系统',
    '量体系统': '量体系统',
    '成衣系统': '成衣系统',
    '系统尺码': '系统尺码',
    '自定义尺码': '自定义尺码',
    '尺码删除成功': '尺码删除成功',
    '删除成功。': '删除成功。',
    '新增成功。': '新增成功。',
    '请选择关联尺码大类。': '请选择关联尺码大类。',
    '尺码新增成功。': '尺码新增成功。',
    '尺码编辑成功。': '尺码编辑成功。',
    '新增服装类别': '新增服装类别',
    '尺码详情': '尺码详情',
    '只显示定制需要参数': '只显示定制需要参数',
    '仅显示命名尺码(新规格不显示)': '仅显示命名尺码(新规格不显示)',
    '保存参数': '保存参数',
    '全新导入': '全新导入',
    '另存为模板': '另存为模板',
    '导入模板': '导入模板',
    '参数设置': '参数设置',
    '必要': '必要',
    '主要': '主要',
    '次要': '次要',
    '占位': '占位',
    '没有尺码数据': '没有尺码数据',
    '主次要': '主次要',
    '模板名称：': '模板名称：',
    '给当前模板命个名吧': '给当前模板命个名吧',
    '模板导入发生错误！': '模板导入发生错误！',
    '模板名称已存在！': '模板名称已存在！',
    '导入成功': '导入成功',
    '尺码重新导入成功。': '尺码重新导入成功。',
    '尺码保存成功。': '尺码保存成功。',
    '新增服装风格': '新增服装风格',
    '风格名称': '风格名称',
    '简码': '简码',
    '引用数': '引用数',
    '确定删除吗': '确定删除吗',
    '新增课程': '新增课程',
    '课程封面': '课程封面',
    '课程级别': '课程级别',
    '课程价格': '课程价格',
    '课程长度': '课程长度',
    '请录入课程名称!': '请录入课程名称!',
    '初级': '初级',
    '中级': '中级',
    '高级': '高级',
    '请选择课程级别!': '请选择课程级别!',
    '课程时长': '课程时长',
    '请录入课程时长!': '请录入课程时长!',
    '小时': '小时',
    '请录入课程价格!': '请录入课程价格!',
    '课程简介': '课程简介',
    '请录入课程简介!': '请录入课程简介!',
    '课程目录': '课程目录',
    '上传PDF': '上传PDF',
    '删除PDF': '删除PDF',
    '试看课程视频': '试看课程视频',
    '新增充值': '新增充值',
    '新增父类目': '新增父类目',
    '输入消息内容进行检索': '输入消息内容进行检索',
    '只显示系统消息': '只显示系统消息',
    '聊天消息': '聊天消息',
    '系统消息': '系统消息',
    '其它消息': '其它消息',
    '发送者': '发送者',
    '消息内容': '消息内容',
    '消息类型': '消息类型',
    '发送时间': '发送时间',
    '消息详情': '消息详情',
    '新增单位': '新增单位',
    '单位名称': '单位名称',
    '事件名称': '事件名称',
    '发生地点': '发生地点',
}
